/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../../../shared/api/custom-instance';

import { customInstance } from '../../../../shared/api/custom-instance';
import type {
  AccountingTypeResponse,
  ErrorResponse,
  GetMastersOptionsParams,
  IdResponse,
  KanResponse,
  KoResponse,
  ListAccountingTypesParams,
  ListKansParams,
  ListKosParams,
  ListMastersFlatParams,
  ListMokusParams,
  MasterAccountingTypeCreateRequest,
  MasterAccountingTypeListResponse,
  MasterAccountingTypePatchRequest,
  MasterFlatListResponse,
  MasterKanCreateRequest,
  MasterKanListResponse,
  MasterKanPatchRequest,
  MasterKoCreateRequest,
  MasterKoListResponse,
  MasterKoPatchRequest,
  MasterMokuCreateRequest,
  MasterMokuListResponse,
  MasterMokuPatchRequest,
  MastersOptionsResponse,
  MokuResponse,
  SuccessResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * マスタオプション取得API

fieldsパラメータで指定された項目のマスタデータを返す。
例: fields=kan で款(kan)のマスタデータを取得

 * @summary マスタオプション取得
 */
export const getMastersOptions = (
  params: GetMastersOptionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MastersOptionsResponse>(
    { url: `/masters/options`, method: 'GET', params, signal },
    options,
  );
};

export const getGetMastersOptionsQueryKey = (params?: GetMastersOptionsParams) => {
  return [`/masters/options`, ...(params ? [params] : [])] as const;
};

export const getGetMastersOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMastersOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetMastersOptionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMastersOptions>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMastersOptionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMastersOptions>>> = ({ signal }) =>
    getMastersOptions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMastersOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMastersOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMastersOptions>>
>;
export type GetMastersOptionsQueryError = ErrorType<ErrorResponse>;

export function useGetMastersOptions<
  TData = Awaited<ReturnType<typeof getMastersOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetMastersOptionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMastersOptions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMastersOptions>>,
          TError,
          Awaited<ReturnType<typeof getMastersOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMastersOptions<
  TData = Awaited<ReturnType<typeof getMastersOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetMastersOptionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMastersOptions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMastersOptions>>,
          TError,
          Awaited<ReturnType<typeof getMastersOptions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMastersOptions<
  TData = Awaited<ReturnType<typeof getMastersOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetMastersOptionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMastersOptions>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary マスタオプション取得
 */

export function useGetMastersOptions<
  TData = Awaited<ReturnType<typeof getMastersOptions>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: GetMastersOptionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMastersOptions>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMastersOptionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * テナントの会計区分一覧を取得します。
 * @summary 会計区分一覧取得
 */
export const listAccountingTypes = (
  params?: ListAccountingTypesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MasterAccountingTypeListResponse>(
    { url: `/masters/accounting-types`, method: 'GET', params, signal },
    options,
  );
};

export const getListAccountingTypesQueryKey = (params?: ListAccountingTypesParams) => {
  return [`/masters/accounting-types`, ...(params ? [params] : [])] as const;
};

export const getListAccountingTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAccountingTypes>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAccountingTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountingTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAccountingTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAccountingTypes>>> = ({ signal }) =>
    listAccountingTypes(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAccountingTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAccountingTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAccountingTypes>>
>;
export type ListAccountingTypesQueryError = ErrorType<ErrorResponse>;

export function useListAccountingTypes<
  TData = Awaited<ReturnType<typeof listAccountingTypes>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ListAccountingTypesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountingTypes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountingTypes>>,
          TError,
          Awaited<ReturnType<typeof listAccountingTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountingTypes<
  TData = Awaited<ReturnType<typeof listAccountingTypes>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAccountingTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountingTypes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAccountingTypes>>,
          TError,
          Awaited<ReturnType<typeof listAccountingTypes>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAccountingTypes<
  TData = Awaited<ReturnType<typeof listAccountingTypes>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAccountingTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountingTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 会計区分一覧取得
 */

export function useListAccountingTypes<
  TData = Awaited<ReturnType<typeof listAccountingTypes>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListAccountingTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAccountingTypes>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAccountingTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 新しい会計区分を作成します。
 * @summary 会計区分作成
 */
export const createAccountingType = (
  masterAccountingTypeCreateRequest: BodyType<MasterAccountingTypeCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdResponse>(
    {
      url: `/masters/accounting-types`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: masterAccountingTypeCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateAccountingTypeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAccountingType>>,
    TError,
    { data: BodyType<MasterAccountingTypeCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAccountingType>>,
  TError,
  { data: BodyType<MasterAccountingTypeCreateRequest> },
  TContext
> => {
  const mutationKey = ['createAccountingType'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAccountingType>>,
    { data: BodyType<MasterAccountingTypeCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createAccountingType(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAccountingTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAccountingType>>
>;
export type CreateAccountingTypeMutationBody = BodyType<MasterAccountingTypeCreateRequest>;
export type CreateAccountingTypeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 会計区分作成
 */
export const useCreateAccountingType = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAccountingType>>,
      TError,
      { data: BodyType<MasterAccountingTypeCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createAccountingType>>,
  TError,
  { data: BodyType<MasterAccountingTypeCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateAccountingTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した会計区分の詳細を取得します。
 * @summary 会計区分詳細取得
 */
export const getAccountingType = (
  accountingTypeId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AccountingTypeResponse>(
    { url: `/masters/accounting-types/${accountingTypeId}`, method: 'GET', signal },
    options,
  );
};

export const getGetAccountingTypeQueryKey = (accountingTypeId?: string) => {
  return [`/masters/accounting-types/${accountingTypeId}`] as const;
};

export const getGetAccountingTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountingType>>,
  TError = ErrorType<ErrorResponse>,
>(
  accountingTypeId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountingType>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountingTypeQueryKey(accountingTypeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountingType>>> = ({ signal }) =>
    getAccountingType(accountingTypeId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!accountingTypeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountingType>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccountingTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountingType>>
>;
export type GetAccountingTypeQueryError = ErrorType<ErrorResponse>;

export function useGetAccountingType<
  TData = Awaited<ReturnType<typeof getAccountingType>>,
  TError = ErrorType<ErrorResponse>,
>(
  accountingTypeId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountingType>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountingType>>,
          TError,
          Awaited<ReturnType<typeof getAccountingType>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccountingType<
  TData = Awaited<ReturnType<typeof getAccountingType>>,
  TError = ErrorType<ErrorResponse>,
>(
  accountingTypeId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountingType>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccountingType>>,
          TError,
          Awaited<ReturnType<typeof getAccountingType>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccountingType<
  TData = Awaited<ReturnType<typeof getAccountingType>>,
  TError = ErrorType<ErrorResponse>,
>(
  accountingTypeId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountingType>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 会計区分詳細取得
 */

export function useGetAccountingType<
  TData = Awaited<ReturnType<typeof getAccountingType>>,
  TError = ErrorType<ErrorResponse>,
>(
  accountingTypeId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccountingType>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAccountingTypeQueryOptions(accountingTypeId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 指定した会計区分を更新します。
空のリクエストボディの場合は何も更新せず、現在の状態をそのまま返します。
年度は変更できません。

 * @summary 会計区分更新
 */
export const updateAccountingType = (
  accountingTypeId: string,
  masterAccountingTypePatchRequest: BodyType<MasterAccountingTypePatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/masters/accounting-types/${accountingTypeId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: masterAccountingTypePatchRequest,
    },
    options,
  );
};

export const getUpdateAccountingTypeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAccountingType>>,
    TError,
    { accountingTypeId: string; data: BodyType<MasterAccountingTypePatchRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAccountingType>>,
  TError,
  { accountingTypeId: string; data: BodyType<MasterAccountingTypePatchRequest> },
  TContext
> => {
  const mutationKey = ['updateAccountingType'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAccountingType>>,
    { accountingTypeId: string; data: BodyType<MasterAccountingTypePatchRequest> }
  > = (props) => {
    const { accountingTypeId, data } = props ?? {};

    return updateAccountingType(accountingTypeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAccountingTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAccountingType>>
>;
export type UpdateAccountingTypeMutationBody = BodyType<MasterAccountingTypePatchRequest>;
export type UpdateAccountingTypeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 会計区分更新
 */
export const useUpdateAccountingType = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAccountingType>>,
      TError,
      { accountingTypeId: string; data: BodyType<MasterAccountingTypePatchRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAccountingType>>,
  TError,
  { accountingTypeId: string; data: BodyType<MasterAccountingTypePatchRequest> },
  TContext
> => {
  const mutationOptions = getUpdateAccountingTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した会計区分を削除します。
紐づく款が存在する場合は削除できません（409 Conflict）。

 * @summary 会計区分削除
 */
export const deleteAccountingType = (
  accountingTypeId: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    { url: `/masters/accounting-types/${accountingTypeId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteAccountingTypeMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAccountingType>>,
    TError,
    { accountingTypeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAccountingType>>,
  TError,
  { accountingTypeId: string },
  TContext
> => {
  const mutationKey = ['deleteAccountingType'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAccountingType>>,
    { accountingTypeId: string }
  > = (props) => {
    const { accountingTypeId } = props ?? {};

    return deleteAccountingType(accountingTypeId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAccountingTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAccountingType>>
>;

export type DeleteAccountingTypeMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 会計区分削除
 */
export const useDeleteAccountingType = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAccountingType>>,
      TError,
      { accountingTypeId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAccountingType>>,
  TError,
  { accountingTypeId: string },
  TContext
> => {
  const mutationOptions = getDeleteAccountingTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 款一覧を取得します。
accounting_type_id を指定すると、その会計区分に属する款のみを取得します。
year を指定すると、その年度の会計区分に属する款のみを取得します。

 * @summary 款一覧取得
 */
export const listKans = (
  params?: ListKansParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MasterKanListResponse>(
    { url: `/masters/kans`, method: 'GET', params, signal },
    options,
  );
};

export const getListKansQueryKey = (params?: ListKansParams) => {
  return [`/masters/kans`, ...(params ? [params] : [])] as const;
};

export const getListKansQueryOptions = <
  TData = Awaited<ReturnType<typeof listKans>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListKansParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKans>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListKansQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listKans>>> = ({ signal }) =>
    listKans(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listKans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListKansQueryResult = NonNullable<Awaited<ReturnType<typeof listKans>>>;
export type ListKansQueryError = ErrorType<ErrorResponse>;

export function useListKans<
  TData = Awaited<ReturnType<typeof listKans>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ListKansParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKans>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKans>>,
          TError,
          Awaited<ReturnType<typeof listKans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListKans<
  TData = Awaited<ReturnType<typeof listKans>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListKansParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKans>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKans>>,
          TError,
          Awaited<ReturnType<typeof listKans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListKans<
  TData = Awaited<ReturnType<typeof listKans>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListKansParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKans>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 款一覧取得
 */

export function useListKans<
  TData = Awaited<ReturnType<typeof listKans>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListKansParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKans>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListKansQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 新しい款を作成します。
 * @summary 款作成
 */
export const createKan = (
  masterKanCreateRequest: BodyType<MasterKanCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdResponse>(
    {
      url: `/masters/kans`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: masterKanCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateKanMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKan>>,
    TError,
    { data: BodyType<MasterKanCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKan>>,
  TError,
  { data: BodyType<MasterKanCreateRequest> },
  TContext
> => {
  const mutationKey = ['createKan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKan>>,
    { data: BodyType<MasterKanCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createKan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateKanMutationResult = NonNullable<Awaited<ReturnType<typeof createKan>>>;
export type CreateKanMutationBody = BodyType<MasterKanCreateRequest>;
export type CreateKanMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 款作成
 */
export const useCreateKan = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createKan>>,
      TError,
      { data: BodyType<MasterKanCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createKan>>,
  TError,
  { data: BodyType<MasterKanCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateKanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した款の詳細を取得します。
 * @summary 款詳細取得
 */
export const getKan = (
  kanId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<KanResponse>(
    { url: `/masters/kans/${kanId}`, method: 'GET', signal },
    options,
  );
};

export const getGetKanQueryKey = (kanId?: string) => {
  return [`/masters/kans/${kanId}`] as const;
};

export const getGetKanQueryOptions = <
  TData = Awaited<ReturnType<typeof getKan>>,
  TError = ErrorType<ErrorResponse>,
>(
  kanId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKan>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetKanQueryKey(kanId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKan>>> = ({ signal }) =>
    getKan(kanId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!kanId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getKan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetKanQueryResult = NonNullable<Awaited<ReturnType<typeof getKan>>>;
export type GetKanQueryError = ErrorType<ErrorResponse>;

export function useGetKan<
  TData = Awaited<ReturnType<typeof getKan>>,
  TError = ErrorType<ErrorResponse>,
>(
  kanId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKan>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKan>>,
          TError,
          Awaited<ReturnType<typeof getKan>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetKan<
  TData = Awaited<ReturnType<typeof getKan>>,
  TError = ErrorType<ErrorResponse>,
>(
  kanId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKan>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKan>>,
          TError,
          Awaited<ReturnType<typeof getKan>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetKan<
  TData = Awaited<ReturnType<typeof getKan>>,
  TError = ErrorType<ErrorResponse>,
>(
  kanId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKan>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 款詳細取得
 */

export function useGetKan<
  TData = Awaited<ReturnType<typeof getKan>>,
  TError = ErrorType<ErrorResponse>,
>(
  kanId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKan>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetKanQueryOptions(kanId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 指定した款を更新します。
空のリクエストボディの場合は何も更新せず、現在の状態をそのまま返します。

 * @summary 款更新
 */
export const updateKan = (
  kanId: string,
  masterKanPatchRequest: BodyType<MasterKanPatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/masters/kans/${kanId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: masterKanPatchRequest,
    },
    options,
  );
};

export const getUpdateKanMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateKan>>,
    TError,
    { kanId: string; data: BodyType<MasterKanPatchRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateKan>>,
  TError,
  { kanId: string; data: BodyType<MasterKanPatchRequest> },
  TContext
> => {
  const mutationKey = ['updateKan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateKan>>,
    { kanId: string; data: BodyType<MasterKanPatchRequest> }
  > = (props) => {
    const { kanId, data } = props ?? {};

    return updateKan(kanId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateKanMutationResult = NonNullable<Awaited<ReturnType<typeof updateKan>>>;
export type UpdateKanMutationBody = BodyType<MasterKanPatchRequest>;
export type UpdateKanMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 款更新
 */
export const useUpdateKan = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateKan>>,
      TError,
      { kanId: string; data: BodyType<MasterKanPatchRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateKan>>,
  TError,
  { kanId: string; data: BodyType<MasterKanPatchRequest> },
  TContext
> => {
  const mutationOptions = getUpdateKanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した款を削除します。
紐づく項が存在する場合は削除できません（409 Conflict）。

 * @summary 款削除
 */
export const deleteKan = (kanId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<SuccessResponse>(
    { url: `/masters/kans/${kanId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteKanMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteKan>>,
    TError,
    { kanId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteKan>>,
  TError,
  { kanId: string },
  TContext
> => {
  const mutationKey = ['deleteKan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteKan>>, { kanId: string }> = (
    props,
  ) => {
    const { kanId } = props ?? {};

    return deleteKan(kanId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteKanMutationResult = NonNullable<Awaited<ReturnType<typeof deleteKan>>>;

export type DeleteKanMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 款削除
 */
export const useDeleteKan = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteKan>>,
      TError,
      { kanId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteKan>>,
  TError,
  { kanId: string },
  TContext
> => {
  const mutationOptions = getDeleteKanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 項一覧を取得します。
kan_id を指定すると、その款に属する項のみを取得します。
year を指定すると、その年度の会計区分に属する款の項のみを取得します。

 * @summary 項一覧取得
 */
export const listKos = (
  params?: ListKosParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MasterKoListResponse>(
    { url: `/masters/kos`, method: 'GET', params, signal },
    options,
  );
};

export const getListKosQueryKey = (params?: ListKosParams) => {
  return [`/masters/kos`, ...(params ? [params] : [])] as const;
};

export const getListKosQueryOptions = <
  TData = Awaited<ReturnType<typeof listKos>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListKosParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKos>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListKosQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listKos>>> = ({ signal }) =>
    listKos(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listKos>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListKosQueryResult = NonNullable<Awaited<ReturnType<typeof listKos>>>;
export type ListKosQueryError = ErrorType<ErrorResponse>;

export function useListKos<
  TData = Awaited<ReturnType<typeof listKos>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ListKosParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKos>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKos>>,
          TError,
          Awaited<ReturnType<typeof listKos>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListKos<
  TData = Awaited<ReturnType<typeof listKos>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListKosParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKos>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listKos>>,
          TError,
          Awaited<ReturnType<typeof listKos>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListKos<
  TData = Awaited<ReturnType<typeof listKos>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListKosParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKos>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 項一覧取得
 */

export function useListKos<
  TData = Awaited<ReturnType<typeof listKos>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListKosParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listKos>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListKosQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 新しい項を作成します。
 * @summary 項作成
 */
export const createKo = (
  masterKoCreateRequest: BodyType<MasterKoCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdResponse>(
    {
      url: `/masters/kos`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: masterKoCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateKoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createKo>>,
    TError,
    { data: BodyType<MasterKoCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createKo>>,
  TError,
  { data: BodyType<MasterKoCreateRequest> },
  TContext
> => {
  const mutationKey = ['createKo'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createKo>>,
    { data: BodyType<MasterKoCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createKo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateKoMutationResult = NonNullable<Awaited<ReturnType<typeof createKo>>>;
export type CreateKoMutationBody = BodyType<MasterKoCreateRequest>;
export type CreateKoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 項作成
 */
export const useCreateKo = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createKo>>,
      TError,
      { data: BodyType<MasterKoCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createKo>>,
  TError,
  { data: BodyType<MasterKoCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateKoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した項の詳細を取得します。
 * @summary 項詳細取得
 */
export const getKo = (
  koId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<KoResponse>(
    { url: `/masters/kos/${koId}`, method: 'GET', signal },
    options,
  );
};

export const getGetKoQueryKey = (koId?: string) => {
  return [`/masters/kos/${koId}`] as const;
};

export const getGetKoQueryOptions = <
  TData = Awaited<ReturnType<typeof getKo>>,
  TError = ErrorType<ErrorResponse>,
>(
  koId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKo>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetKoQueryKey(koId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getKo>>> = ({ signal }) =>
    getKo(koId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!koId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getKo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetKoQueryResult = NonNullable<Awaited<ReturnType<typeof getKo>>>;
export type GetKoQueryError = ErrorType<ErrorResponse>;

export function useGetKo<
  TData = Awaited<ReturnType<typeof getKo>>,
  TError = ErrorType<ErrorResponse>,
>(
  koId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKo>>,
          TError,
          Awaited<ReturnType<typeof getKo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetKo<
  TData = Awaited<ReturnType<typeof getKo>>,
  TError = ErrorType<ErrorResponse>,
>(
  koId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getKo>>,
          TError,
          Awaited<ReturnType<typeof getKo>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetKo<
  TData = Awaited<ReturnType<typeof getKo>>,
  TError = ErrorType<ErrorResponse>,
>(
  koId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKo>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 項詳細取得
 */

export function useGetKo<
  TData = Awaited<ReturnType<typeof getKo>>,
  TError = ErrorType<ErrorResponse>,
>(
  koId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getKo>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetKoQueryOptions(koId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 指定した項を更新します。
空のリクエストボディの場合は何も更新せず、現在の状態をそのまま返します。

 * @summary 項更新
 */
export const updateKo = (
  koId: string,
  masterKoPatchRequest: BodyType<MasterKoPatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/masters/kos/${koId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: masterKoPatchRequest,
    },
    options,
  );
};

export const getUpdateKoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateKo>>,
    TError,
    { koId: string; data: BodyType<MasterKoPatchRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateKo>>,
  TError,
  { koId: string; data: BodyType<MasterKoPatchRequest> },
  TContext
> => {
  const mutationKey = ['updateKo'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateKo>>,
    { koId: string; data: BodyType<MasterKoPatchRequest> }
  > = (props) => {
    const { koId, data } = props ?? {};

    return updateKo(koId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateKoMutationResult = NonNullable<Awaited<ReturnType<typeof updateKo>>>;
export type UpdateKoMutationBody = BodyType<MasterKoPatchRequest>;
export type UpdateKoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 項更新
 */
export const useUpdateKo = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateKo>>,
      TError,
      { koId: string; data: BodyType<MasterKoPatchRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateKo>>,
  TError,
  { koId: string; data: BodyType<MasterKoPatchRequest> },
  TContext
> => {
  const mutationOptions = getUpdateKoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した項を削除します。
紐づく目が存在する場合は削除できません（409 Conflict）。

 * @summary 項削除
 */
export const deleteKo = (koId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<SuccessResponse>(
    { url: `/masters/kos/${koId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteKoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteKo>>,
    TError,
    { koId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteKo>>,
  TError,
  { koId: string },
  TContext
> => {
  const mutationKey = ['deleteKo'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteKo>>, { koId: string }> = (
    props,
  ) => {
    const { koId } = props ?? {};

    return deleteKo(koId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteKoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteKo>>>;

export type DeleteKoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 項削除
 */
export const useDeleteKo = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteKo>>,
      TError,
      { koId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<typeof deleteKo>>, TError, { koId: string }, TContext> => {
  const mutationOptions = getDeleteKoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 目一覧を取得します。
ko_id を指定すると、その項に属する目のみを取得します。
year を指定すると、その年度の会計区分に属する款の項の目のみを取得します。

 * @summary 目一覧取得
 */
export const listMokus = (
  params?: ListMokusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MasterMokuListResponse>(
    { url: `/masters/mokus`, method: 'GET', params, signal },
    options,
  );
};

export const getListMokusQueryKey = (params?: ListMokusParams) => {
  return [`/masters/mokus`, ...(params ? [params] : [])] as const;
};

export const getListMokusQueryOptions = <
  TData = Awaited<ReturnType<typeof listMokus>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListMokusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMokus>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMokusQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMokus>>> = ({ signal }) =>
    listMokus(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMokus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMokusQueryResult = NonNullable<Awaited<ReturnType<typeof listMokus>>>;
export type ListMokusQueryError = ErrorType<ErrorResponse>;

export function useListMokus<
  TData = Awaited<ReturnType<typeof listMokus>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ListMokusParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMokus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMokus>>,
          TError,
          Awaited<ReturnType<typeof listMokus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMokus<
  TData = Awaited<ReturnType<typeof listMokus>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListMokusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMokus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMokus>>,
          TError,
          Awaited<ReturnType<typeof listMokus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMokus<
  TData = Awaited<ReturnType<typeof listMokus>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListMokusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMokus>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 目一覧取得
 */

export function useListMokus<
  TData = Awaited<ReturnType<typeof listMokus>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListMokusParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMokus>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMokusQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 新しい目を作成します。
 * @summary 目作成
 */
export const createMoku = (
  masterMokuCreateRequest: BodyType<MasterMokuCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdResponse>(
    {
      url: `/masters/mokus`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: masterMokuCreateRequest,
      signal,
    },
    options,
  );
};

export const getCreateMokuMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMoku>>,
    TError,
    { data: BodyType<MasterMokuCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMoku>>,
  TError,
  { data: BodyType<MasterMokuCreateRequest> },
  TContext
> => {
  const mutationKey = ['createMoku'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMoku>>,
    { data: BodyType<MasterMokuCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createMoku(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMokuMutationResult = NonNullable<Awaited<ReturnType<typeof createMoku>>>;
export type CreateMokuMutationBody = BodyType<MasterMokuCreateRequest>;
export type CreateMokuMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 目作成
 */
export const useCreateMoku = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMoku>>,
      TError,
      { data: BodyType<MasterMokuCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createMoku>>,
  TError,
  { data: BodyType<MasterMokuCreateRequest> },
  TContext
> => {
  const mutationOptions = getCreateMokuMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した目の詳細を取得します。
 * @summary 目詳細取得
 */
export const getMoku = (
  mokuId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MokuResponse>(
    { url: `/masters/mokus/${mokuId}`, method: 'GET', signal },
    options,
  );
};

export const getGetMokuQueryKey = (mokuId?: string) => {
  return [`/masters/mokus/${mokuId}`] as const;
};

export const getGetMokuQueryOptions = <
  TData = Awaited<ReturnType<typeof getMoku>>,
  TError = ErrorType<ErrorResponse>,
>(
  mokuId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoku>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMokuQueryKey(mokuId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMoku>>> = ({ signal }) =>
    getMoku(mokuId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!mokuId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMoku>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMokuQueryResult = NonNullable<Awaited<ReturnType<typeof getMoku>>>;
export type GetMokuQueryError = ErrorType<ErrorResponse>;

export function useGetMoku<
  TData = Awaited<ReturnType<typeof getMoku>>,
  TError = ErrorType<ErrorResponse>,
>(
  mokuId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoku>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMoku>>,
          TError,
          Awaited<ReturnType<typeof getMoku>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMoku<
  TData = Awaited<ReturnType<typeof getMoku>>,
  TError = ErrorType<ErrorResponse>,
>(
  mokuId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoku>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMoku>>,
          TError,
          Awaited<ReturnType<typeof getMoku>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetMoku<
  TData = Awaited<ReturnType<typeof getMoku>>,
  TError = ErrorType<ErrorResponse>,
>(
  mokuId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoku>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 目詳細取得
 */

export function useGetMoku<
  TData = Awaited<ReturnType<typeof getMoku>>,
  TError = ErrorType<ErrorResponse>,
>(
  mokuId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMoku>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetMokuQueryOptions(mokuId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 指定した目を更新します。
空のリクエストボディの場合は何も更新せず、現在の状態をそのまま返します。

 * @summary 目更新
 */
export const updateMoku = (
  mokuId: string,
  masterMokuPatchRequest: BodyType<MasterMokuPatchRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<SuccessResponse>(
    {
      url: `/masters/mokus/${mokuId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: masterMokuPatchRequest,
    },
    options,
  );
};

export const getUpdateMokuMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMoku>>,
    TError,
    { mokuId: string; data: BodyType<MasterMokuPatchRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMoku>>,
  TError,
  { mokuId: string; data: BodyType<MasterMokuPatchRequest> },
  TContext
> => {
  const mutationKey = ['updateMoku'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMoku>>,
    { mokuId: string; data: BodyType<MasterMokuPatchRequest> }
  > = (props) => {
    const { mokuId, data } = props ?? {};

    return updateMoku(mokuId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMokuMutationResult = NonNullable<Awaited<ReturnType<typeof updateMoku>>>;
export type UpdateMokuMutationBody = BodyType<MasterMokuPatchRequest>;
export type UpdateMokuMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 目更新
 */
export const useUpdateMoku = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMoku>>,
      TError,
      { mokuId: string; data: BodyType<MasterMokuPatchRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMoku>>,
  TError,
  { mokuId: string; data: BodyType<MasterMokuPatchRequest> },
  TContext
> => {
  const mutationOptions = getUpdateMokuMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 指定した目を削除します。目は最下位階層のため、常に削除可能です。
 * @summary 目削除
 */
export const deleteMoku = (mokuId: string, options?: SecondParameter<typeof customInstance>) => {
  return customInstance<SuccessResponse>(
    { url: `/masters/mokus/${mokuId}`, method: 'DELETE' },
    options,
  );
};

export const getDeleteMokuMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMoku>>,
    TError,
    { mokuId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMoku>>,
  TError,
  { mokuId: string },
  TContext
> => {
  const mutationKey = ['deleteMoku'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMoku>>, { mokuId: string }> = (
    props,
  ) => {
    const { mokuId } = props ?? {};

    return deleteMoku(mokuId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMokuMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMoku>>>;

export type DeleteMokuMutationError = ErrorType<ErrorResponse>;

/**
 * @summary 目削除
 */
export const useDeleteMoku = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteMoku>>,
      TError,
      { mokuId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMoku>>,
  TError,
  { mokuId: string },
  TContext
> => {
  const mutationOptions = getDeleteMokuMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * 会計区分・款・項・目をフラット構造で取得します。
 * @summary 歳出科目一覧取得（フラット構造）
 */
export const listMastersFlat = (
  params?: ListMastersFlatParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MasterFlatListResponse>(
    { url: `/masters/flat`, method: 'GET', params, signal },
    options,
  );
};

export const getListMastersFlatQueryKey = (params?: ListMastersFlatParams) => {
  return [`/masters/flat`, ...(params ? [params] : [])] as const;
};

export const getListMastersFlatQueryOptions = <
  TData = Awaited<ReturnType<typeof listMastersFlat>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListMastersFlatParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMastersFlat>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMastersFlatQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMastersFlat>>> = ({ signal }) =>
    listMastersFlat(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMastersFlat>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMastersFlatQueryResult = NonNullable<Awaited<ReturnType<typeof listMastersFlat>>>;
export type ListMastersFlatQueryError = ErrorType<ErrorResponse>;

export function useListMastersFlat<
  TData = Awaited<ReturnType<typeof listMastersFlat>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | ListMastersFlatParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMastersFlat>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMastersFlat>>,
          TError,
          Awaited<ReturnType<typeof listMastersFlat>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMastersFlat<
  TData = Awaited<ReturnType<typeof listMastersFlat>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListMastersFlatParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMastersFlat>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMastersFlat>>,
          TError,
          Awaited<ReturnType<typeof listMastersFlat>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListMastersFlat<
  TData = Awaited<ReturnType<typeof listMastersFlat>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListMastersFlatParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMastersFlat>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 歳出科目一覧取得（フラット構造）
 */

export function useListMastersFlat<
  TData = Awaited<ReturnType<typeof listMastersFlat>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: ListMastersFlatParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listMastersFlat>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListMastersFlatQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
